import { z } from 'zod'
import { oc } from '@orpc/contract'
import { US_STATE_CODES } from '../../practitioner/handlers/member-credentials.contract'

/**
 * Whether BeHuman schedules visits in the caller's state yet (PD-1628), for the registration
 * schedule step: an uncovered state replaces the calendar with the coverage-expansion screen.
 *
 * Self-scoped: the subject is the authenticated patient. `state` is the Patient State State Match
 * reads (the chart address, PD-1610), null when undetermined — the portal then keeps the normal
 * calendar. `covered` is false only for a known state with no clinician licensed in it; the call
 * then also flags the patient as an Unmatched Patient (PD-1928), which is the state's waitlist.
 * `waitlisted` says whether that flag is on file — false when covered or when the write failed.
 */
export const patientMeSchedulingCoverage = oc
  .route({ method: 'GET', path: '/v2/patient/me/scheduling-coverage' })
  .output(
    z.object({
      state: z.enum(US_STATE_CODES).nullable(),
      covered: z.boolean(),
      waitlisted: z.boolean(),
    }),
  )
